<ng-container *ngIf="toaster">
  <div
    class="toaster-unit js-toaster-{{ toaster.id }} toaster-{{
      toaster.type === TOASTER_TYPE.UPDATE_CART_ITEM ? TOASTER_TYPE.PRIMARY : toaster.type
    }}"
  >
    <!-- Icon -->
    <div class="toaster-icon">
      @if (toaster.type === TOASTER_TYPE.SUCCESS) {
        <span class="material-symbols-outlined">check_circle</span>
      } @else if (toaster.type === TOASTER_TYPE.DANGER) {
        <span class="material-symbols-outlined">cancel</span>
      } @else if (toaster.type === TOASTER_TYPE.WARNING) {
        <span class="material-symbols-outlined">warning</span>
      } @else if (toaster.type === TOASTER_TYPE.INFO) {
        <span class="material-symbols-outlined">info</span>
      } @else {
        <span class="material-symbols-outlined">notifications</span>
      }
    </div>

    <!-- Content -->
    <div class="box-content">
      @if (toaster.title) {
        <div class="title" [innerHTML]="toaster.title"></div>
      }

      @if (toaster.type === TOASTER_TYPE.UPDATE_CART_ITEM) {
        <div class="content add-to-cart">
          <div class="product-info">
            <div class="box-image">
              <cx-media [media]="(toaster.cartItem?.product?.medias?.images)![0].cartIcon" />
            </div>
            <div class="box-details">
              <p>{{ toaster.cartItem?.product?.description }}</p>
              <a [routerLink]="['/carrinho']" routerLinkActive="router-link-active" class="btn-link">Ver no Carrinho</a>
            </div>
          </div>
        </div>
      } @else {
        <div class="content" [innerHTML]="toaster.content"></div>
      }
    </div>

    <!-- Close -->
    <button type="button" class="box-close" (click)="closeIt(toaster.id!)">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
</ng-container>
